<template>
    <div class="mt-15">
        <div v-if="bloqueo==0">
            <v-row>
                <v-col cols="12" class="mt-10 text-center">
                    <img src="@/assets/denegado.png" />
                </v-col>
            </v-row>
        </div>
        <div v-else-if="bloqueo==1">
            <v-container>
                <v-row class="mt-2">
                    <v-col cols="12" md="8">
                        <span>Selecciona Cliente</span>
                        <v-btn v-if="opc!='Nuevo'" @click="d_cliente=true" class="ml-5" x-small color="indigo" dark rounded fab><v-icon small>find_replace</v-icon></v-btn>
                        <v-btn v-else class="ml-5" x-small color="grey" dark rounded fab><v-icon small>find_replace</v-icon></v-btn>
                    </v-col>
                    <v-col cols="12" md="4" class="mt-n5">
                        <v-radio-group v-model="opc" row>
                        <v-radio @click="clsInput()" label="Nuevo" value="Nuevo"></v-radio>
                        <v-radio @click="clsInput()" label="Modificar" value="Modificar"></v-radio>
                        </v-radio-group>
                    </v-col>
                </v-row>
                <v-row class="mt-7">
                    <v-col cols="12" md="2" class="mt-n7">
                        <v-text-field label="Rut" maxlength="10" class='text-body-2' v-model="rut" dense outlined rounded></v-text-field>
                    </v-col>
                    <v-col cols="12" md="5" class="mt-n7">
                        <v-text-field label="Nombre" class='text-body-2' v-model="cliente" dense outlined rounded></v-text-field>
                    </v-col>
                </v-row>
                <v-row class="mt-5">
                    <v-col cols="12" md="6" class="mt-n7">
                        <v-text-field label="Direccion" class='text-body-2' v-model="direccion" dense outlined rounded></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3" class="mt-n7">
                        <v-text-field label="Comuna" class='text-body-2' v-model="comuna" dense outlined rounded></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3" class="mt-n7">
                        <v-text-field label="Ciudad" class='text-body-2' v-model="ciudad" dense outlined rounded></v-text-field>
                    </v-col>
                </v-row>
                <v-row class="mt-5"> 
                    <v-col cols="12" md="4" class="mt-n7">
                        <v-text-field label="Email" class='text-body-2' v-model="email" dense outlined rounded></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3" class="mt-n7">
                        <v-text-field label="Teléfono" class='text-body-2' v-model="telefono" dense outlined rounded></v-text-field>
                    </v-col>
                </v-row>
                <v-row class="mt-5">
                    <v-col cols="4" md="2" class="mt-n7">
                        <v-select class='text-caption' v-model="estado" :items="estados" label="Estado" dense outlined rounded></v-select>
                    </v-col>
                </v-row>
                <v-row class="mt-n10">
                    <v-col cols="12" md="6"></v-col>
                    <v-col cols="6" md="3" class="text-end">
                        <v-btn @click="clsInput()" small color="teal" dark rounded block><span class="text-caption">Limpiar</span></v-btn>
                    </v-col>
                    <v-col cols="6" md="3" class="text-end">
                        <v-btn v-if="opc!='Nuevo'" @click="update_cliente()" small color="teal" dark rounded block><span class="text-caption">Modificar</span></v-btn>
                        <v-btn v-else @click="save_cliente()" small color="teal" dark rounded block><span class="text-caption">Grabar</span></v-btn>
                    </v-col>
                </v-row>
            </v-container>
        </div>
            <div style="height: 50px;"></div>
            <v-footer height="50" color="#c1680e" fixed></v-footer>

        <v-dialog v-model="d_cliente" persistent max-width="600">
            <v-card color="#fff" rounded>
                <v-card-title>
                    Clientes
                    <v-spacer></v-spacer>
                    <v-icon @click="d_cliente=false">close</v-icon>
                </v-card-title>
                <v-card-text>
                    <v-simple-table fixed-header dense height="300">
                            <thead>
                                <tr>
                                    <th style="background-color: lightgrey;">Rut</th>
                                    <th style="background-color: lightgrey;">Nombre</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr @click="handClients(item)" v-for="item in myClientes" :key="item.ID">
                                    <td><span class="text-body-2">{{ item.Rut }}</span></td>
                                    <td><span class="text-body-2">{{ item.Cliente }}</span></td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                </v-card-text>
            </v-card>
        </v-dialog>


        <v-dialog v-model="loading" persistent max-width="300">
            <v-card color="#fff" rounded="xl">
                <v-card-text>
                    <v-row class="mt-2">
                        <v-col cols="12" class="text-center">
                            <h3 class="mb-2">Procesando ...</h3>
                            <v-progress-linear indeterminate color="red"></v-progress-linear>
                        </v-col>
                    </v-row>
                </v-card-text>

            </v-card>
        </v-dialog>

        <v-snackbar v-model="snack" timeout="3000" :color="color_snack">
            <div class="d-flex justify-center">                
                <h4>{{mensaje}}</h4>
            </div>
        </v-snackbar>
    </div>
</template>
<script>
import axios from "axios";
export default {
    name: 'Clientes',
    data: () => ({
        contrato:null,
        user:null,
        apikey:null,
        snack:false,
        color_snack:'',
        mensaje:'',
        bloqueo:null,
        loading:false,

        opc:'Nuevo',

        id_cliente:0,
        rut:'',
        cliente:'',
        direccion:'',
        comuna:'',
        ciudad:'',
        email:'',
        telefono:'',
        d_cliente:false,
        myClientes:[],
        estados:['V','N'],
        estado:'V',

    }),
    async mounted(){
        const myToken = localStorage.getItem('mytoken');
        const myUser = localStorage.getItem('myuser');
        const myContrato = localStorage.getItem('mycontrato');
        const myTime = localStorage.getItem('timeuser');
        if(myToken!=null && myUser!=null && myContrato!=null){
        //verificamos la expiracion
        const ahora = new Date();
        const expira = new Date(myTime);
        if(ahora > expira){
            this.goLogin()
        } else {
            this.apikey = myToken;
            this.contrato = myContrato;
            this.user = myUser;
            this.loading=true;
            this.bloqueo = await this.myPermiso(8);
            if(parseInt(this.bloqueo)!=0){
                await this.search_clientes();
            };
            this.loading=false
        }
        } else {
            this.goLogin();
        }
    },
    methods:{
        goLogin(){
            localStorage.removeItem('mytoken');
            localStorage.removeItem('myuser');
            localStorage.removeItem('mycontrato');
            localStorage.removeItem('timeuser');
            this.$router.push({name:'Login'})
        },
        async myPermiso(id){
            let result = 0;
            try {
                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' : this.user,
                    'id' : id
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/permission/',params,{headers});
                const datos = res.data;
                if(datos[0].existe=='si'){
                    result = parseInt(datos[0].acceso);
                }
            } catch (error) {
                console.log(error)
            }
            return result
        },
        clsInput(){
            this.id_cliente=0,
            this.rut='';
            this.cliente='';
            this.direccion='';
            this.comuna='';
            this.ciudad='';
            this.email='';
            this.telefono='';
            this.estado='V';
        },
        async search_clientes(){
            try {
                const headers = {
                    'Content-Type': 'application/json',
                    'Authorization': 'Token ' + this.apikey
                };
                const params = {
                    'contrato' : this.contrato,
                    'user' : this.user,
                    'clients' : 'all'
                };
                const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/clients/',params,{headers});
                const datos = res.data;
                console.log('clientes',datos);
                if(datos[0].existe=='si'){
                    this.myClientes = datos;
                }
            } catch (error) {
                console.log(error)
            }
        },
        handClients(item){
            console.log(item)
            this.id_cliente=item.ID;
            this.rut=item.Rut;
            this.cliente=item.Cliente;
            this.direccion=item.Direccion;
            this.comuna=item.Comuna;
            this.ciudad=item.Ciudad;
            this.email=item.Email;
            this.telefono=item.Telefono;
            this.estado=item.Estado;
            this.d_cliente=false
        },
        async exists_clients(){
            let result = false;
            const filter = this.myClientes.filter(res => res.Rut == this.rut);
            if(filter.length!=0){ result = true };
            return result
        },
        async save_cliente(){
            this.loading=true;
            if(this.rut!=null && this.rut!='' && this.cliente!=null && this.cliente!=''){
                const exists = await this.exists_clients();
                if(!exists){
                    try {
                        const headers = {
                            'Content-Type': 'application/json',
                            'Authorization': 'Token ' + this.apikey
                        };
                        const params = {
                            'contrato' : this.contrato,
                            'user' : this.user,
                            'rut':this.rut,
                            'cliente':this.cliente,
                            'direccion':this.direccion,
                            'comuna':this.comuna,
                            'ciudad':this.ciudad,
                            'email':this.email,
                            'telefono':this.telefono,
                            'estado':this.estado
                        };
                        const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/save/clients/',params,{headers});
                        const datos = res.data;
                        if(datos[0].existe=='si'){
                            await this.search_clientes();
                            this.color_snack='success';
                            this.mensaje='Cliente ingresado con exito';
                            this.snack=true
                        }
                    } catch (error) {
                        console.log(error)
                    }
                } else {
                    this.color_snack='error';
                    this.mensaje='Cliente ingresado ya existe';
                    this.snack=true
                }
            } else {
                this.color_snack='error';
                this.mensaje='Ingrese datos del cliente';
                this.snack=true
            };
            this.loading=false;
        },
        async update_cliente(){
            this.loading=true;
            if(this.rut!=null && this.rut!='' && this.cliente!=null && this.cliente!=''){
                try {
                    const headers = {
                        'Content-Type': 'application/json',
                        'Authorization': 'Token ' + this.apikey
                    };
                    const params = {
                        'contrato' : this.contrato,
                        'user' : this.user,
                        'id': this.id_cliente,
                        'rut':this.rut,
                        'cliente':this.cliente,
                        'direccion':this.direccion,
                        'comuna':this.comuna,
                        'ciudad':this.ciudad,
                        'email':this.email,
                        'telefono':this.telefono,
                        'estado':this.estado
                    };
                    const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/update/clients/',params,{headers});
                    const datos = res.data;
                    if(datos[0].existe=='si'){
                        await this.search_clientes();
                        this.color_snack='success';
                        this.mensaje='Cliente modificado con exito';
                        this.snack=true
                    }
                } catch (error) {
                    console.log(error)
                }
            } else {
                this.color_snack='error';
                this.mensaje='Ingrese datos del cliente';
                this.snack=true
            };
            this.loading=false;
        },
        
    }
}
</script>
